import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CmsHeadTags, CmsContainerPage, CmsPageLayout } from '@grandvisionhq/bloomreach';
import { ErrorPage } from '@grandvisionhq/layout';
import { useTrackErrorPageView } from '@grandvisionhq/svc-tealium/hooks';

const ErrorPageComponent = (props)=>{
    const { buttonText , image , subheader , title , statusCode  } = props;
    useTrackErrorPageView({
        statusCode
    });
    // If we receive a 404, we can assume that we still have a pagemodel, so we want to return the header and footer as well
    if (statusCode === 404) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CmsHeadTags, {
            title: title,
            noIndex: true,
            noFollow: true
        }), /*#__PURE__*/ React.createElement(CmsContainerPage, null, /*#__PURE__*/ React.createElement(CmsPageLayout, null, /*#__PURE__*/ React.createElement(ErrorPage, {
            header: title,
            buttonText: buttonText,
            image: image,
            subheader: subheader
        }))));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CmsHeadTags, {
        title: title,
        noIndex: true,
        noFollow: true
    }), /*#__PURE__*/ React.createElement(ErrorPage, {
        header: title,
        buttonText: buttonText,
        image: image,
        subheader: subheader
    }));
};
const withErrorPage = (errorProps)=>{
    return (PageComponent)=>{
        const WithErrorPage = (props)=>{
            const { statusCode  } = props;
            if (statusCode && statusCode >= 400) {
                return /*#__PURE__*/ React.createElement(ErrorPageComponent, swcHelpers.extends({}, props, {
                    statusCode: statusCode
                }));
            }
            return /*#__PURE__*/ React.createElement(PageComponent, swcHelpers.extends({}, props));
        };
        WithErrorPage.getInitialProps = function() {
            var _ref = swcHelpers.asyncToGenerator(function*(ctx) {
                var ref;
                const pageProps = (PageComponent.getInitialProps ? yield PageComponent.getInitialProps(ctx) : null) || {};
                if (pageProps.statusCode && ctx.res) {
                    ctx.res.statusCode = pageProps.statusCode;
                }
                const extractedLocale = (ref = ctx.req) === null || ref === void 0 ? void 0 : ref.locale.toString();
                if (extractedLocale && (errorProps === null || errorProps === void 0 ? void 0 : errorProps[extractedLocale])) {
                    return swcHelpers.objectSpread({}, pageProps, errorProps[extractedLocale]);
                } else if (errorProps) {
                    return swcHelpers.objectSpread({}, pageProps, errorProps);
                }
                return pageProps;
            });
            return function(ctx) {
                return _ref.apply(this, arguments);
            };
        }();
        WithErrorPage.displayName = `WithErrorPage(${PageComponent.displayName || PageComponent.name || 'Unknown'})`;
        return WithErrorPage;
    };
};

export { withErrorPage as default };
//# sourceMappingURL=with-error-page.js.map
